import { NgModule } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { RouterModule, PreloadAllModules } from '@angular/router';

import { AgmCoreModule } from '@agm/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ShareButtonsModule } from 'ngx-sharebuttons';
import { TranslateModule } from '@ngx-translate/core';
import { MetaModule } from '@ngx-meta/core';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';

import { LoadingModule } from '@shared/modules/loading';
import { AlertModule } from '@shared/modules/alert';

import { AlertService } from '@shared/modules/alert';
import { WindowRef, LanguageService } from '@shared/services';

import { ROUTES } from './app.routes';
import { AppComponent } from './app.component';

@NgModule({
  bootstrap: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(ROUTES, {
      useHash: false,
      preloadingStrategy: PreloadAllModules
    }),
    TranslateModule.forRoot(),
    NgbModule.forRoot(),
    MetaModule.forRoot(),
    ShareButtonsModule.forRoot(),
    SlimLoadingBarModule.forRoot(),
    LoadingModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAfaoZqx-4NQeLls54f9dLlT-1uPZTKBfU',
      libraries: ['places']
    }),
    AlertModule.forRoot()
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    WindowRef,
    LanguageService,
    AlertService
  ]
})
export class AppModule {

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.module.ts